import { SkeletonBoundsBase } from '@pixi-spine/base';
class SkeletonBounds extends SkeletonBoundsBase {}
export { SkeletonBounds };
